module.exports = {
  emptyMessage: 'Please, insert your name',
  defaultMessage: 'Invalid name',
};
